/**
 * Created by Daniel Wang on 1/15/2024.
 * Description: Editor Component for Street Events Configuration
 * ------ maintenance history ------
 */

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { UntypedFormControl } from '@angular/forms';
import { AppState } from '../../../../redux';
import * as _lodash from 'lodash';

import { SlideSheetService } from '../../../../services/slide-sheet.service';
import { SlideSheetActionTypes } from '../../../slide-sheet/slide-sheet.model';
import { StreetEventConfig } from '../../../../tamalelibs/models/admin-page.model';
import { adminSharedPageConstants } from '../../admin-page-setting.constants';
import { AdminPageActionTypes } from '../../../../redux/actions/admin-page.actions';

@Component({
    selector: 'tam-se-configuration-edit',
    templateUrl: './se-configuration-edit.component.html',
    styleUrls: ['./se-configuration-edit.component.scss']
})
export class SEConfigurationEditorComponent implements OnInit, OnDestroy {
    @Input() data?: any;

    isEdit = false;
    username = new UntypedFormControl('');
    password = new UntypedFormControl('');
    server = new UntypedFormControl('');
    path = new UntypedFormControl('');
    filename = new UntypedFormControl('');
    title = 'Street event config';
    streetEventConfig = new StreetEventConfig();

    //#region private properties
    private _destroySubscriptions: Array<Subscription> = [];
    //#endregion

    constructor(
        private _store: Store<AppState>,
        private _slideSheetService: SlideSheetService,
    ) { }

    ngOnInit() {
        // edit data
        if (this.data) {
            this.isEdit = true;
            this.streetEventConfig = _lodash.cloneDeep(this.data);
        }
    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
        this._destroySubscriptions = [];
    }

    onSlideSheetClose() {
        this._slideSheetService.slideSheetActionSubject$.next({
            type: SlideSheetActionTypes.CLOSE
        });
    }

    /** Check the length of name. When the length of the name is valid, dispatches action to the store to create new entity or edit entity. */
    onSubmitClick() {
        let isCheckFailed = false;

        this.username.setErrors(null);
        if (!this.username.value) {
            this.username.setErrors({
                required: true
            });
            isCheckFailed = true;
        } else if (this.username.value.length > 128) {
            this.username.setErrors({
                maxlength: true
            });
            isCheckFailed = true;
        }

        this.password.setErrors(null);
        if (!this.password.value) {
            this.password.setErrors({
                required: true
            });
            isCheckFailed = true;
        }

        this.server.setErrors(null);
        if (!this.server.value) {
            this.server.setErrors({
                required: true
            });
            isCheckFailed = true;
        }

        this.path.setErrors(null);
        if (!this.path.value) {
            this.path.setErrors({
                required: true
            });
            isCheckFailed = true;
        }

        this.filename.setErrors(null);
        if (!this.filename.value) {
            this.filename.setErrors({
                required: true
            });
            isCheckFailed = true;
        }

        if (!isCheckFailed) {
            if (this.isEdit) {
                this._store.dispatch({
                    type: AdminPageActionTypes.EDIT_SHARED_PAGE,
                    payload: {
                        type: adminSharedPageConstants['se-configuration'].type,
                        key: 'streetEventsConfig',
                        item: this.streetEventConfig
                    }
                });
            } else {
                this._store.dispatch({
                    type: AdminPageActionTypes.CREATE_SHARED_PAGE,
                    payload: {
                        type: adminSharedPageConstants['se-configuration'].type,
                        key: 'streetEventsConfig',
                        item: this.streetEventConfig
                    }
                });
            }
        }
    }
}
